angular.module('workflow.app')

.factory( 'WorkflowStepTemplate', ( Model, StepModifier, Api ) ->

  class WorkflowStepTemplate extends Model

    init: ->
      @stepmodifier = @stepmodifier || {}
      @stepmodifier = new Api.StepModifier( @stepmodifier )
      StepModifier.decorate( @stepmodifier )
      @$stepConfigSources = []
      @$stepConfigSourcesLoadRequested = false
      @isLoadingSources = false

    getNewCustomSource: () ->
      {}

    getNewCuratedSource: () ->
      {}

    addCustomSource: ( customSource )->
      @stepmodifier.addCustomSource( customSource )

    addCuratedSource: ( curatedSource )->
      @stepmodifier.addCuratedSource( curatedSource )

    getCustomSources: ->
      @stepmodifier.getCustomSources()

    getCuratedSources: ->
      @stepmodifier.getCuratedSources()

    getStepConfigSources: ->
      @loadStepConfigSources()
      @$stepConfigSources

    loadStepConfigSources: ->
      if @$stepConfigSourcesLoadRequested
        return

      @$stepConfigSourcesLoadRequested = true
      @$isLoadingSources = true
      Api.Engine.get({ step: @config, limit: 2000 }).$promise.then ( sources ) =>
        @$isLoadingSources = false
        @$stepConfigSources = sources.results

    removeCustomSource: ( customSource) ->
      @stepmodifier.removeCustomSource( customSource )

    removeCuratedSource: ( curatedSource ) ->
      @stepmodifier.removeCuratedSource( curatedSource )

    updateCustomSource: ( existingCustomSource, modifications ) ->
      angular.extend( existingCustomSource, modifications )

    updateCuratedSource: ( existingCuratedSource, modifications ) ->
      angular.extend( existingCuratedSource, modifications )

    toggleSourceExclusion: ( source ) ->
      @stepmodifier.toggleSourceExclusion( source )

    isExcluded: ( source ) ->
      @stepmodifier.isExcluded( source )

    getSources: ->
      customSources = @getCustomSources().map (customSource) ->
        customSource.$$type = 'custom'
        customSource
      curatedSources = @getCuratedSources().map (curatedSource) ->
        curatedSource.$$type = 'curated'
        curatedSource
      stepConfigSources = @getStepConfigSources().map ( stepConfigSource ) ->
        stepConfigSource.$$type = 'stepConfig'
        stepConfigSource

      if @isLoadingSources
        sources = []
        sources.$$loading = true
      else
        sources = customSources.concat( curatedSources, stepConfigSources )
        sources.$$loading = false

      return sources
)
